<template>
	<component :is="$store.state.auth.role"></component>
</template>

<script>
import Client from '../components/profile/EditClient'
import Author from '../components/profile/EditAuthor'
import Manager from '../components/profile/EditManager'
import Admin from '../components/profile/EditAdmin'
import Partner from '../components/profile/EditPartner'
import Supervisor from '../components/profile/EditSupervisor'

export default {
	name: "EditProfile",
	components: {
		Client,
		Author,
		Manager,
		Admin,
		Partner,
		Supervisor,
	}
}
</script>

<style scoped>

</style>
